/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Book_BodyInputs */

const en_portal_step_book_body = /** @type {(inputs: Portal_Step_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click an open hour. The confirmation and the reminder send themselves.`)
};

const pl_portal_step_book_body = /** @type {(inputs: Portal_Step_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikasz w wolną godzinę. Potwierdzenie i przypomnienie przychodzą same.`)
};

/**
* | output |
* | --- |
* | "Click an open hour. The confirmation and the reminder send themselves." |
*
* @param {Portal_Step_Book_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_book_body = /** @type {((inputs?: Portal_Step_Book_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Book_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_book_body(inputs)
	return en_portal_step_book_body(inputs)
});